<template>
  <div id="faqModal">
    <div class="faq__container">
      <div class="faq__left">
        <div class="left__text">
          <p class="text__top">
            누구나 따라할 수는 있지만, 아무나 따라올 수는 없습니다.
          </p>
          <p class="text__middle">
            홈핏은 방문 PT 1위* 브랜드 파워를 바탕으로 최다 회원 수를 보유하여 다양한 수업 기회를 제공합니다.<br/>
            또한 회원∙전문가 관리 전담 부서를 통한 체계적인 시스템을 갖추고 있습니다.
          </p>
          <p class="text__bottom">
            (* 2024년 6월 현재 누적 수업 횟수, 회원 수, 기업 고객사 수, 매출액, 수업 수, 전문가 수 기준)
          </p>
        </div>
        <div class="left__info">
          <div>
            <p class="info__title">회원 수/기업 고객사 수</p>
            <p class="info__content">국내 1위</p>
          </div>
          <div>
            <p class="info__title">누적 수업 횟수</p>
            <p class="info__content">180,000 회 +</p>
          </div>
          <div>
            <p class="info__title">최다 회원 보유</p>
            <p class="info__content">117,600 명 +</p>
          </div>
          <div>
            <p class="info__title">최다 전문가 보유</p>
            <p class="info__content">2,000 명 +</p>
          </div>
        </div>
      </div>
      <i class="faq__right" @click="closeFaqModal" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'FqaModal',
  mounted() {
    const html = document.querySelector('html')
    html.style.overflow = 'hidden'
  },
  beforeDestroy() {
    const html = document.querySelector('html')
    html.style.removeProperty('overflow')
  },
  methods: {
    closeFaqModal() {
      this.$emit('close-faq-modal')
    }
  }
}
</script>
